import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { Subscription, switchMap, timer } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { MatSort } from '@angular/material/sort';

import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { SseService } from 'src/app/services/SseService';
import { BrokerService } from 'src/app/services/broker.services';
import { RastreadorService } from 'src/app/services/rastreador.service';
import { CookieService } from 'ngx-cookie-service';
import { urlMercado } from 'src/app/utils/mercado-url.util';

@Component({
  selector: 'app-tabla-compania',
  templateUrl: './tabla-compania.component.html',
  styleUrl: './tabla-compania.component.scss'
})
export class TablaCompaniaComponent implements OnInit, OnDestroy {
  @Input() fechaInicial: any;
  private static readonly REFRESCO_VARIACION_MS = 5 * 60 * 1000;
  // Lista completa; companiaData es esta lista con la variación aplicada y ordenada.
  private companiasBase: any[] = [];
  // Variación % entre el último y el penúltimo cierre diario, por idNectum.
  private variaciones = new Map<number, number>();
  private subVariacion: Subscription | null = null;
  private lastSort: Sort | null = null;
  @ViewChild(MatSort) sort!: MatSort;
  private subCompania = new Subscription;
  public companiaData = new CdkTableVirtualScrollDataSource<any>;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestion!: CdkVirtualScrollViewport;
  public loadCompania: boolean;
  public subLoadCompania: Subscription;
  public subCompAnalisis: Subscription;
  private subIdMercado: Subscription;
  private idMercadoAnt: number;

  tableColumns : TableColmuns []=[
    
    {id: 'n', name:'Nº', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'nombre', name:'Nombre', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'ultimoEarnig', name:'Ultimo Earnig', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'proximoEarnig', name:'Proximo Earnig',isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'dias', name:'Dias', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'variacion', name:'Var. %', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'precio', name:'Cotizacion', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'volumen', name:'Volumen', isShow: false, isDate: false, isNumber: true, isString: false},
   {id: 'indicador1', name:'ATR', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'indicador2', name:'Vol: Historica', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'indicador3', name:'Vol: Relativa', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'indicador4', name:'Desviacion Standard', isShow: false, isDate: false, isNumber: true, isString: false},
  ]

   displayedColumns: string[] = ['n', 'nombre','ultimoEarnig','proximoEarnig','dias', 'precio', 'volumen'];
  filaSeleccionada: any=null;

  constructor (private _rastreadorservice: RastreadorService,
              private _httclient: HttpClient,
              private _brokerService: BrokerService,
              private _sseServcie: SseService,
              private _cookieService: CookieService
  ){

  }
  ngOnDestroy(): void {
    this.subCompania.unsubscribe();
    this.subLoadCompania.unsubscribe();
    this.subCompAnalisis.unsubscribe();
    this.subIdMercado.unsubscribe();
    this.subVariacion?.unsubscribe();
  }

  // Pide los dos últimos cierres diarios del mercado (tbl_historicos, periodo 6) y los refresca
  // cada 5 min: con la sesión abierta la última vela es la del día y va cambiando.
  private iniciarVariacion(idMercado: number, token: string): void {
    this.subVariacion?.unsubscribe();
    this.variaciones.clear();
    const jsonData = { idmercado: idMercado, idNectum: 0 };
    this.subVariacion = timer(0, TablaCompaniaComponent.REFRESCO_VARIACION_MS).pipe(
      switchMap(() => this._sseServcie.apiPostNew('mercado/tendenciaCompaniasPorMercado', jsonData, token))
    ).subscribe({
      next: (data: any) => {
        this.variaciones = new Map((data ?? []).map((t: any) =>
          [Number(t.idNectum), (t.ultimoClose - t.penultimoClose) / t.penultimoClose * 100]));
        this.refrescarTabla();
      }
    });
  }

  private refrescarTabla(): void {
    // Se escribe sobre las mismas filas para no perder la referencia de filaSeleccionada.
    for (const c of this.companiasBase) {
      c.variacion = this.variaciones.get(Number(c.idNectum)) ?? null;
    }
    this.companiaData = new CdkTableVirtualScrollDataSource(this.ordenar(this.companiasBase));
  }


  ngOnInit(): void {
    this.subCompania = this._rastreadorservice.valCompaniasRastreador$.subscribe({
      next: (data: any)=>{
        let objetosTransformados = data.map((data: { timeProximo: string; proximo: string | null; timeActual: string; fecha: string | null }) => {
          const proximoEarnig = this.composeDateLabel(data.timeProximo, data.proximo);
          const ultimoEarnig = this.composeDateLabel(data.timeActual, data.fecha);
          return {
            ...data,
            proximoEarnig: proximoEarnig,
            ultimoEarnig: ultimoEarnig
          };
        });

        this.companiasBase = this.flattenArray(objetosTransformados);
        this.refrescarTabla();
      }
    });
    this.subLoadCompania = this._rastreadorservice.valloadCompania$.subscribe({
      next: (data: any)=>{
        this.loadCompania = data;
      }
    });
    this.subCompAnalisis = this._rastreadorservice.valcompaniaAnalisis$.subscribe({
      next: (data: any)=>{

        this.companiasBase = this.compareNectumCheck(this.companiasBase, this.flattenArray(data));
        console.log("subCompAnalisis = this._rastreadorservice.temporal$ ", this.companiasBase);
        this.refrescarTabla();

      }
    });
    // Carga la lista de compañías del mercado seleccionado. Se dispara desde este componente
    // (no desde app-crear-modelo) para que la petición solo ocurra mientras la tabla está
    // visible: al ocultarse el panel, *ngIf destruye este componente y cancela la suscripción.
    const token = this._cookieService.get('auth_token');
    this.subIdMercado = this._rastreadorservice.idMercado$.subscribe({
      next: (data: any) => {
        if (this.idMercadoAnt == data) {
          return;
        }
        this.idMercadoAnt = data;
        this.iniciarVariacion(data, token);
        this._rastreadorservice.updateloadCompania(true);
        const jsonData = { idmercado: data, idNectum: 0 };
        this._sseServcie.apiPostNew('mercado/buscadorCompaniasPorMercadoRastreador', jsonData, token).subscribe({
          next: (data: any) => {
            this._rastreadorservice.updateCompaniaRastreador(data);
            this._rastreadorservice.updateloadCompania(false);
          }
        });
      }
    });
    // Inicializa las columnas visibles según isShow (o todas si no está definido)
    if (this.tableColumns?.length) {
      const visible = this.tableColumns.filter(c => c.isShow === true);
      this.displayedColumns = (visible.length ? visible : this.tableColumns).map(c => c.id);
      // Sincroniza isShow si venía indefinido
      this.tableColumns = this.tableColumns.map(c => ({ ...c, isShow: this.displayedColumns.includes(c.id) }));
    }
  }

  ngAfterViewInit() {
    // Remove this line as it's causing the error
    // this.companiaData.sort = this.sort;
  }

  private formatDate(dateString: string | null | undefined): string {
    if (!dateString) {
      return '-';
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime()) || date.getFullYear() === 1970) {
      return '-';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private composeDateLabel(prefix: string | null | undefined, dateValue: string | null | undefined): string {
    const formattedDate = this.formatDate(dateValue);
    if (formattedDate === '-') {
      return '-';
    }

    const trimmedPrefix = (prefix ?? '').trim();
    return trimmedPrefix ? `${trimmedPrefix} ${formattedDate}` : formattedDate;
  }

  compareNectumCheck(companias: any[], stocks: any[]): any[] {
    return companias.map(compania => {
      const stock = stocks.find(stock => stock.idnectum === compania.idNectum);
      if (stock && stock.estado && !compania.nombre.startsWith('✔ ')) {
        return {
          ...compania,
          nombre: '✔ '+compania.nombre
        };
      }
      return compania;
    });
  }
  

  /** Abre el activo en /mercados dentro del mercado del rastreador. 'nombre' trae el iso (con '✔ ' si ya está en el broker). */
  urlMercadoActivo(item: any): string {
    const idmercado = item?.idMercado || this.idMercadoAnt;
    const iso = (item?.nombre ?? '').replace(/^✔\s*/, '');
    return idmercado ? urlMercado({ idmercado }, iso) : '/mercados';
  }

  selectRow(row: any){
    let temporal=JSON.parse(JSON.stringify(row));
    this.filaSeleccionada=row;
    this._rastreadorservice.updateloadVolatilCompania(true);
    this._rastreadorservice.updateCompaniaSelec(temporal);
    this._rastreadorservice.updateIdNectumSeries(temporal.idNectum);
    let companyName = JSON.parse(JSON.stringify(temporal.nombre.replace(/^✔\s*/, '')));
    
    let from = this.fechaInicial || '2018-01-01';
    let url='v3/historical-price-full-rastreador/'+companyName+'?from='+from;
    //console.log(url);
    if(this.filaSeleccionada){
      this._sseServcie.apiGetNew(url).subscribe({
        next: (data: any)=>{
          this._rastreadorservice.updatecompaniaVolatividad(data.historical);
          this._rastreadorservice.updateloadVolatilCompania(false);
        }
      });
    } 
    console.log("this.selectefilesad: despues ", this.filaSeleccionada);
  }

  flattenArray(arrayOfArrays: any[]): any[] {
    
    return arrayOfArrays.flatMap(innerArray => innerArray);
  }

  getCellWidth(columnId: string): number {
    if (columnId === 'n' || columnId === 'dias') {
      return 20; // Ancho en píxeles para las columnas 'n' y 'dias'
    }
    return 60; // Resto de las columnas sin ancho fijo
  }
  
  getHeaderWidth(columnId: string): number {
    if (columnId === 'n' ) {
      return 20; // Ancho en píxeles para las columnas 'n' y 'dias'
    }
    if (columnId === 'dias') {
      return 25; // Ancho en píxeles para las columnas 'n' y 'dias'
    }
    if (columnId === 'nombre') {
      return 30; // Ancho en píxeles para la columna 'nombre'
    }

    return 60; // Resto de las columnas sin ancho fijo
  }

  sortData(sort: Sort) {
    this.lastSort = sort;
    this.refrescarTabla();
  }

  private ordenar(lista: any[]): any[] {
    const data = [...lista];
    const sort = this.lastSort;
    if (!sort || !sort.active || sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      const column = this.tableColumns.find(col => col.id === sort.active);
      
      if (!column) return 0;

      // Sin dato (p. ej. variación de un activo con menos de dos cierres): siempre al final.
      const sinA = a[sort.active] == null, sinB = b[sort.active] == null;
      if (sinA || sinB) return sinA === sinB ? 0 : (sinA ? 1 : -1);

      if (column.isNumber) {
        return compare(Number(a[sort.active]), Number(b[sort.active]), isAsc);
      } else if (column.isDate) {
        return compare(new Date(a[sort.active]), new Date(b[sort.active]), isAsc);
      } else {
        return compare(a[sort.active], b[sort.active], isAsc);
      }
    });
  }

  panelOpenState = false; // controla el acordeón
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }

  toggleColumnVisibility(id: string, checked?: boolean): void {
    const col = this.tableColumns.find(c => c.id === id);
    if (!col) return;

    const isChecked = checked ?? !col.isShow;
    col.isShow = isChecked;

    if (isChecked) {
      const set = new Set(this.displayedColumns);
      set.add(id);
      this.displayedColumns = this.tableColumns.map(c => c.id).filter(cid => set.has(cid));
    } else {
      this.displayedColumns = this.displayedColumns.filter(c => c !== id);
    }
  }
}

function compare(a: any, b: any, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
